import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteAssetCase($companyId: ID!, $id: ID!) {
    deleteAssetCase(companyId: $companyId, id: $id) {
      assetCase {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
